/* tslint:disable */

/**
 */
export class StudEqpPrm {
    ID_STUD_EQP_PRM?: number;
    ID_STUDY_EQUIPMENTS?: number;
    VALUE_TYPE?: number;
    VALUE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/stud-eqp-prm.ts